import './contact.css';

(function() {
  'use strict';

  /**
   * ContactController - contrôleur de la page de contact
   */
  angular
    .module('observatoireApp')
    .controller('ContactController', ['$scope', '$http', '$timeout', '$window', function($scope, $http, $timeout, $window) {
      
      // Initialisation du modèle de formulaire
      $scope.contact = {
        name: '',
        email: '',
        subject: '',
        message: ''
      };
      
      // Variables d'état du formulaire
      $scope.isSending = false;
      $scope.submitSuccess = false;
      $scope.submitError = false;
      
      // Configuration de la carte Google Maps
      $scope.mapConfig = {
        center: {
          lat: 12.134568, 
          lng: 15.055729
        },
        zoom: 15,
        apiKey: 'AIzaSyCZYNQ751SMXs9FB3G0HBsVhNB2PWKRodU'
      };
      
      /**
       * Initialise la carte Google Maps
       */
      $scope.initGoogleMap = function() {
        // Vérifier si Google Maps API est chargée
        if (!$window.google || !$window.google.maps) {
          console.error('Google Maps API non chargée');
          return;
        }
        
        // Créer la carte avec les options
        const mapOptions = {
          center: new google.maps.LatLng($scope.mapConfig.center.lat, $scope.mapConfig.center.lng),
          zoom: $scope.mapConfig.zoom,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          styles: [
            {
              featureType: "administrative",
              elementType: "geometry",
              stylers: [{ visibility: "on" }]
            },
            {
              featureType: "poi",
              stylers: [{ visibility: "simplified" }]
            }
          ]
        };
        
        // Initialiser la carte
        const map = new google.maps.Map(document.getElementById('google-map'), mapOptions);
        
        // Ajouter un marqueur
        const marker = new google.maps.Marker({
          position: new google.maps.LatLng($scope.mapConfig.center.lat, $scope.mapConfig.center.lng),
          map: map,
          title: 'Observatoire Tchadien des Finances Publiques',
          animation: google.maps.Animation.DROP
        });
        
        // Ajouter une info-bulle
        const infoWindow = new google.maps.InfoWindow({
          content: `
            <div style="max-width: 200px; text-align: center;">
              <h5 style="margin: 0; padding: 5px;">Observatoire Tchadien des Finances Publiques</h5>
              <p style="margin: 5px 0;">Avenue Charles de Gaulle<br>N'Djamena, Tchad</p>
            </div>
          `
        });
        
        // Ouvrir l'info-bulle au clic sur le marqueur
        marker.addListener('click', function() {
          infoWindow.open(map, marker);
        });
        
        // Ouvrir l'info-bulle par défaut
        infoWindow.open(map, marker);
      };
      
      // Charger le script Google Maps API
      $scope.loadGoogleMapsScript = function() {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${$scope.mapConfig.apiKey}&callback=initMap`;
        script.async = true;
        script.defer = true;
        
        // Définir la fonction callback globale
        $window.initMap = function() {
          $scope.initGoogleMap();
        };
        
        document.head.appendChild(script);
      };
      
      // Charger la carte une fois que le DOM est chargé
      angular.element(document).ready(function() {
        $scope.loadGoogleMapsScript();
      });
      
      /**
       * Soumission du formulaire de contact
       */
      $scope.submitForm = function() {
        $scope.isSending = true;
        $scope.submitSuccess = false;
        $scope.submitError = false;

        $http.post('/api/contact', $scope.contact)
          .then(function() {
            handleSuccess();
            $scope.contact = { name: '', email: '', subject: '', message: '' };
            if ($scope.contactForm) {
              $scope.contactForm.$setPristine();
              $scope.contactForm.$setUntouched();
            }
          })
          .catch(function() {
            handleError();
          });
      };
      
      /**
       * Gestion du succès de l'envoi
       */
      function handleSuccess() {
        $scope.isSending = false;
        $scope.submitSuccess = true;
        
        // Masquer le message de succès après 5 secondes
        $timeout(function() {
          $scope.submitSuccess = false;
        }, 5000);
      }
      
      /**
       * Gestion de l'erreur d'envoi
       */
      function handleError() {
        $scope.isSending = false;
        $scope.submitError = true;
        
        // Masquer le message d'erreur après 5 secondes
        $timeout(function() {
          $scope.submitError = false;
        }, 5000);
      }
      
    }]);
})();
